import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "10db698e-5d6f-4c3d-9b59-9f71d2490fe0", 
    authority: "https://login.microsoftonline.com/b7be26fb-0007-4e34-9f39-088aa7bc74b0", 
    redirectUri: "https://simulator.dev-telematicsct.com/device-listing",
    postLogoutRedirectUri: "https://simulator.dev-telematicsct.com/device-listing",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", 
    storeAuthStateInCookie: false,  
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["api://a2442dc6-3f1a-4414-ad63-120f0e84ac3b/access_as_user" ],
};